import styled from "styled-components";

export const StyledMarkdownText = styled.span``;
